import type { Route } from "next";
import type { AppModule } from "@/core/types/app-module.type";

export const getAppModules = (): AppModule[] => {
    
    const appModules: AppModule[] = [
        {
            id: "sig",
            label: "sign_in.label",
            path: "https://trav.navairra.com/sig" as Route,
        },
        {
            id: "reg",
            label: "registration.label",
            path: "https://trav.navairra.com/reg" as Route,
        },
        {
            id: "home",
            label: "home.title",
            path: "/home" as Route,
        },
        {
            id: "flight-req",
            label: "flightReq.title",
            path: "/flight-req" as Route,
        },
        {
            id: "services",
            label: "services.title",
            path: "/services" as Route,
        },
        {
            id: "contact",
            label: "contact.title",
            path: "/contact" as Route,
        },
    ];

    return appModules;
};
